import { RefObject, useRef } from 'react'

type useScrollToRefReturnType<T> = {
  htmlElRef: RefObject<T>
  scrollToElement: () => void | undefined
}

export function useScrollToRef<T extends HTMLDivElement>(
  options: ScrollIntoViewOptions
): useScrollToRefReturnType<T> {
  const htmlElRef = useRef<T>(null)
  const scrollToElement = () => htmlElRef.current?.scrollIntoView(options)
  return { htmlElRef, scrollToElement }
}

export default useScrollToRef
